<template>
  <!-- prettier-ignore -->
  <FormItem :error="error" :prop="fieldName">
    <span v-if="label !== undefined" slot="label" class="n-field-label">{{ $t(`label.${label}`) }}</span>
    <span v-if="customLabel !== undefined" slot="label" class="n-field-label">{{ customLabel }}</span>
    <div :class="modifiedIcon ? 'n-input-item-icon' : 'n-input-item'">
      <i-select ref="select" :value="value" :placeholder="placeholder === undefined ? '' : this.$t(`label.${placeholder}`)" :filterable="filterable" :clearable="clearable" :disabled="disabled" transfer @on-open-change="onOpenChange" @on-change="v => { this.$emit('input', v); this.$emit('on-change', v); }" @on-select="v => { this.$emit('on-select', v) }">
        <template v-if="allOption">
          <Option :value="allOptionValue" :style="{ borderBottom: options.length > 0 ? '1px solid #e8eaec' : '0' }">ALL</Option>
        </template>
        <Option v-for="option in options" :key="option.value" :value="option.value" :disabled="option.disabled">{{ option.name | enumName }}</Option>
      </i-select>
    </div>
    <Tooltip v-if="isModified" placement="right-start" :max-width="500" :content="showName(initValue)" transfer class="ml-2">
      <Icon custom="fas fa-pen" size="14" style="cursor: pointer;" />
    </Tooltip>
  </FormItem>
</template>

<script>
import Base from '../base';
import { getEnum } from '@/store';
import i18n from '@/locale/i18n';
import { isEmpty, isEmptyOption } from '@/helpers/utils';
import { filter, includes as lodashIncludes, last, split } from 'lodash-es';
import _ from 'lodash-es';

export default Base.extend({
  name: 'NFieldEnum',
  props: {
    value: Number,
    enumName: String,
    allOption: Boolean,
    allOptionValue: {
      type: Number,
      default: 0,
    },
    includes: {
      type: Array,
      default() {
        return [];
      },
    },
    filter: {
      type: Array,
      default() {
        return [];
      },
    },
    disabledItems: {
      type: Array,
      default() {
        return [];
      },
    },
    filterable: {
      type: Boolean,
      detail: false,
    },
    clearable: {
      type: Boolean,
      detail: false,
    },
  },
  computed: {
    options() {
      let options = getEnum(this.enumName);

      /* include */
      let includes = this.includes;
      if (includes.length > 0) options = filter(options, e => lodashIncludes(includes, e.value));

      /* disabledItem */
      let disabledItems = this.disabledItems;
      if (disabledItems.length > 0)
        options.forEach(e => {
          e.disabled = disabledItems.filter(v => v === e.value).length > 0;
        });

      /* filter */
      if (!isEmpty(this.filter))
        options = _.filter(options, o => {
          return this.filter.find(f => f === o.value) === undefined;
        });

      return options;
    },
    isModified() {
      return this.showModifyIcon && this.initValue !== this.value;
    },
  },
  created() {
    this.initValue = this.value;
  },
  methods: {
    onOpenChange(isOpen) {
      if (!isOpen || !isEmptyOption(this.value)) return;
      this.$nextTick(() => {
        this.$refs.select.$el.lastChild.scrollTop = 0;
      });
    },
    showName(value) {
      if (isEmpty(value)) return null;
      if (this.allOption && value === this.allOptionValue) return 'ALL';
      let option = this.options.find(f => f.value === value);
      if (isEmpty(option) || value === this.allOptionValue) return null;
      const locale = i18n && i18n.locale ? i18n.locale : 'en';
      return this.$te(option.name, locale) ? this.$t(option.name) : last(split(option.name, '.'));
    },
  },
});
</script>

<style lang="scss" scoped>
@import '../base';
@import 'style';
</style>
